import useWebsiteBuilder, { PresaveWebsiteBuilderStyle, WebsiteBuilder_presaveExists, WebsiteBuilderContent, WebsiteBuilderStyle } from "Hooks/useWebsiteBuilder";
import { makeKey, styx } from "modules/Utils";
import { CSSProperties } from "react";
import Icon from 'elements/Icon';
import { STREAMING_PLATFORMS_INFO } from "modules/Const";

interface PresavePreviewContentProps {
    contentIndex: number;
    websiteContent: WebsiteBuilderContent[];
    websiteStyle: WebsiteBuilderStyle;
    style?: CSSProperties;
    onClickContentBlock?: (index: number) => void;
}

const PresavePreviewContent = ({
    contentIndex,
    websiteContent: websiteContentProp,
    websiteStyle: websiteStyleProp,
    style: styleProp,
    onClickContentBlock,
}: PresavePreviewContentProps) => {
    const {
        websiteContent: websiteContentState,
        websiteStyle: websiteStyleState,
    } = useWebsiteBuilder() as WebsiteBuilder_presaveExists;

    const websiteContent = websiteContentProp || websiteContentState;
    const websiteStyle = websiteStyleProp || websiteStyleState;

    const {
        textColor,
        fontFamily,
        secondaryColor,
    } = websiteStyle;

    const presaveContent = websiteContent[contentIndex].presaveContent;
    if (!presaveContent) {
        return null;
    }

    const {
        presave,
        style,
    } = presaveContent;

    const {
        platforms,
    } = presave;

    const getPresaveContentStyle = () => {
        switch (style) {
            case PresaveWebsiteBuilderStyle.BOXES:
                return {
                    outer: {},
                    inner: {}
                };
            case PresaveWebsiteBuilderStyle.STACKED:
                return {
                    outer: {},
                    inner: {}
                };
            case PresaveWebsiteBuilderStyle.TRADITIONAL:
                return {
                    outer: {
                        paddingLeft: 0,
                        paddingRight: 0,
                        gap: 0,
                        borderBottom: `1px solid ${textColor}`,
                    },
                    inner: {}
                };
            default:
                return {
                    outer: {},
                    inner: {},
                };
        }
    }

    // NOTE: render()
    return (
        <div
            className="presavePreviewContentComponent"
            style={styx(
                sty.presavePreviewContentComponent,
                getPresaveContentStyle().outer,
                styleProp,
            )}
            onClick={() => onClickContentBlock?.(contentIndex)}
        >
            {platforms.map((platform, index) => {
                const platformInfo = STREAMING_PLATFORMS_INFO[platform.name];
                if (!platformInfo || !platform.isEnabled) {
                    return null;
                }

                switch (style) {
                    case PresaveWebsiteBuilderStyle.BOXES:
                        return (
                            <div
                                key={makeKey(platform.name, index, contentIndex)}
                                className="presavePreviewBoxes"
                                style={styx(
                                    sty.presavePreviewBoxes,
                                    { backgroundColor: secondaryColor }
                                )}
                            >
                                <Icon
                                    className="presavePreviewBoxesIcon"
                                    icon={platformInfo.iconPlatform || platformInfo.icon}
                                    size={100}
                                    color={textColor}
                                />
                            </div>
                        )
                    case PresaveWebsiteBuilderStyle.STACKED:
                        return (
                            <div
                                className="presavePreviewStacked"
                                style={styx(
                                    sty.presavePreviewStacked,
                                    { backgroundColor: secondaryColor }
                                )}
                            >
                                <Icon
                                    className="presavePreviewStackedIcon"
                                    icon={platformInfo.iconPlatform || platformInfo.icon}
                                    size={140}
                                    color={textColor}
                                />
                            </div>
                        )
                    case PresaveWebsiteBuilderStyle.TRADITIONAL:
                        return (
                            <div
                                className="presavePreviewTraditional"
                                style={styx(
                                    sty.presavePreviewTraditional,
                                    {
                                        borderColor: textColor,
                                        borderStyle: 'solid',
                                        borderTopWidth: 1,
                                    }
                                )}
                            >
                                <Icon
                                    className="presavePreviewTraditionalIcon"
                                    icon={platformInfo.iconPlatform || platformInfo.icon}
                                    size={140}
                                    color={textColor}
                                />
                                <div
                                    className="presavePreviewButton"
                                    style={styx(
                                        sty.presavePreviewButton,
                                        {
                                            backgroundColor: secondaryColor,
                                            color: textColor,
                                            cursor: 'pointer',
                                            marginLeft: 'auto',
                                        }
                                    )}
                                >
                                    Pre-Save
                                </div>
                            </div>
                        )
                    default:
                        return null
                }
            })}
            {/* <pre>
                {JSON.stringify(presaveContent, null, 4)}
            </pre> */}
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    presavePreviewContentComponent: {
        display: 'flex',
        paddingLeft: 16,
        paddingRight: 16,
        flexWrap: 'wrap',
        gap: 8,
        justifyContent: 'center',
    },
    presavePreviewBoxes: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'calc(50% - 4px)',
        borderRadius: 8,
        padding: 8,
        cursor: 'pointer',
        gap: 8,
    },
    presavePreviewStacked: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        borderRadius: 8,
        padding: 8,
        cursor: 'pointer',
    },
    presavePreviewTraditional: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 4,
        paddingBottom: 4,
        cursor: 'pointer',
    },
    presavePreviewButton: {
        padding: 8,
        borderRadius: 8,
    }
}

export default PresavePreviewContent;